// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { PromotionModel } from "@insite/client-framework/Types/ApiModels";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import CartLineNotes, { CartLineNotesStyles } from "@insite/content-library/Widgets/Cart/CartLineNotes";
import CartLineQuantity, { CartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
// import { productLineProps } from "@store/Themes/common/props/productLine"; // Store Custom Code
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import ProductLineVariantTraitValues from "@store/Library/Components/ProductLineVariantTraitValues";
import { ProductVariantTraitValuesPresentationProps } from "@store/Library/Components/ProductVariantTraitValues";
import { productLineProps } from "@store/Themes/common/props/productLine";
/* Store Custom Code - End */

interface OwnProps {
    cart: Cart;
    promotions?: PromotionModel[];
    showSavingsAmount: boolean;
    showSavingsPercent: boolean;
    editable: boolean;
    showInvalidPriceMessage?: boolean;
    extendedStyles?: CartLineCardExpandedStyles;
    // Starter Custom Code
    overridedStyles?: CartLineCardExpandedStyles;
}

const mapStateToProps = (state: ApplicationState) => ({
    enableVat: getSettingsCollection(state).productSettings.enableVat,
    vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
    showPricing: state.context.showPricing,
    isCheckoutReviewAndSubmitPage: getCurrentPage(state).type === "CheckoutReviewAndSubmitPage",
});

type Props = OwnProps & HasCartLineContext & ReturnType<typeof mapStateToProps>;

export interface CartLineCardExpandedStyles {
    cartLineNotes?: CartLineNotesStyles;
    price?: ProductPriceStyles;
    quantity?: CartLineQuantityStyles;
    container?: GridContainerProps;
    productImageGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    orderLineInfoGridItem?: GridItemProps;
    orderLineInfoContainer?: GridContainerProps;
    productDescriptionAndPartNumbersGridItem?: GridItemProps;
    productDescriptionAndPartNumbersContainer?: GridContainerProps;
    productBrand?: ProductBrandStyles;
    productBrandAndDescriptionGridItem?: GridItemProps;
    productDescription?: ProductDescriptionStyles;
    configurationGridItem?: GridItemProps;
    configurationOptionText?: TypographyProps;
    productPartNumbersGridItem?: GridItemProps;
    productPartNumbers?: ProductPartNumbersStyles;
    orderLineNotesGridItem?: GridItemProps;
    notesHeadingAndText?: SmallHeadingAndTextStyles;
    costCodeGridItem?: GridItemProps;
    costCodeValueText?: TypographyPresentationProps;
    costCodeLabelText?: TypographyPresentationProps;
    productPriceAndQuantityGridItem?: GridItemProps;
    productPriceAndQuantityContainer?: GridContainerProps;
    priceGridItem?: GridItemProps;
    priceHeadingAndText?: SmallHeadingAndTextStyles;
    promotionNameText?: TypographyProps;
    quantityGridItem?: GridItemProps;
    qtyHeadingAndText?: SmallHeadingAndTextStyles;
    extendedUnitNetPriceGridItem?: GridItemProps;
    extendedUnitNetPrice?: SmallHeadingAndTextStyles;
    subtotalWithoutVatText?: SmallHeadingAndTextStyles;
    vatAmount?: SmallHeadingAndTextStyles;
    cartLineErrorMessageGridItem?: GridItemProps;
    cartLineErrorMessageText?: TypographyProps;
    // Starter Custom Code
    extendedUnitNetPriceLabel?: TypographyPresentationProps;
    extendedUnitNetPriceText?: TypographyPresentationProps;
    subtotalWithoutVat?: TypographyPresentationProps;
    vatLabelText?: TypographyPresentationProps;
    cartLineErrorMessageInfosBox?: InfosBoxProps;
    // Store Custom Code
    variantTraitValues?: ProductVariantTraitValuesPresentationProps;
}

export const cartLineCardExpandedStyles: CartLineCardExpandedStyles = {
    container: productLineProps.container,
    productImageGridItem: productLineProps.imageGridItem,
    productImage: productLineProps.image,
    orderLineInfoGridItem: productLineProps.contentGridItem,
    orderLineInfoContainer: productLineProps.contentContainer,
    productDescriptionAndPartNumbersGridItem: productLineProps.infoGridItem,
    productDescriptionAndPartNumbersContainer: productLineProps.infoContainer,
    productBrandAndDescriptionGridItem: productLineProps.descriptionGridItem,
    productBrand: productLineProps.brand,
    productDescription: productLineProps.description,
    productPartNumbersGridItem: productLineProps.partNumbersGridItem,
    productPartNumbers: productLineProps.partNumbers,
    configurationGridItem: productLineProps.configurationGridItem,
    configurationOptionText: productLineProps.configuration,
    costCodeGridItem: productLineProps.costCodeGridItem,
    costCodeLabelText: productLineProps.costCodeLabel,
    costCodeValueText: productLineProps.costCodeText,
    productPriceAndQuantityGridItem: productLineProps.pricingGridItem,
    productPriceAndQuantityContainer: productLineProps.pricingContainer,
    priceGridItem: productLineProps.priceGridItem,
    price: productLineProps.price,
    promotionNameText: productLineProps.promotion,
    quantityGridItem: productLineProps.quantityGridItem,
    quantity: productLineProps.quantity,
    extendedUnitNetPriceGridItem: productLineProps.subtotalGridItem,
    extendedUnitNetPriceLabel: productLineProps.subtotalLabel,
    extendedUnitNetPriceText: productLineProps.subtotalValue,
    subtotalWithoutVat: productLineProps.subtotalSecondValue,
    vatLabelText: productLineProps.subtotalVatLabel,
    cartLineErrorMessageGridItem: productLineProps.messageGridItem,
    cartLineErrorMessageInfosBox: productLineProps.messageInfosBox,
    /* Store Custom Code - Start */
    variantTraitValues: productLineProps.variantTraitValues,
    /* Store Custom Code - End */
};

const CartLineCardExpanded = ({
    cart,
    cartLine,
    showSavingsAmount,
    showSavingsPercent,
    promotions,
    editable,
    enableVat,
    vatPriceDisplay,
    showInvalidPriceMessage,
    showPricing,
    isCheckoutReviewAndSubmitPage,
    extendedStyles,
    // Starter Custom Code
    overridedStyles,
}: Props) => {
    const styles = useExpandProps(cartLineCardExpandedStyles, extendedStyles, overridedStyles); // Starter Custom Code

    return (
        <GridContainer
            {...styles.container}
            data-test-selector={`cartline_expanded_${cartLine.productId}_${cartLine.unitOfMeasure}`}
        >
            {/* Starter Custom Code - Start */}
            {(cartLine.isRestricted || !cartLine.isActive) && (
                <GridItem {...styles.cartLineErrorMessageGridItem}>
                    {cartLine.isRestricted && (
                        <InfosBox
                            {...styles.cartLineErrorMessageInfosBox}
                            data-test-selector="cartline_restrictedMessage"
                        >
                            {translate("Restricted product")}
                        </InfosBox>
                    )}
                    {!cartLine.isActive && (
                        <InfosBox
                            {...styles.cartLineErrorMessageInfosBox}
                            data-test-selector="savedordercartline_inactiveErrorMessage"
                        >
                            {translate("Inactive Product")}
                        </InfosBox>
                    )}
                </GridItem>
            )}
            {/* Starter Custom Code - End */}
            <GridItem {...styles.productImageGridItem}>
                <ProductImage product={cartLine} extendedStyles={styles.productImage} />
            </GridItem>
            <GridItem {...styles.orderLineInfoGridItem}>
                <GridContainer {...styles.orderLineInfoContainer}>
                    <GridItem {...styles.productDescriptionAndPartNumbersGridItem}>
                        <GridContainer {...styles.productDescriptionAndPartNumbersContainer}>
                            <GridItem {...styles.productBrandAndDescriptionGridItem}>
                                {cartLine.brand && (
                                    <ProductBrand brand={cartLine.brand} extendedStyles={styles.productBrand} />
                                )}
                                <ProductDescription product={cartLine} extendedStyles={styles.productDescription} />
                            </GridItem>
                            {/* Starter Custom Code - Start */}
                            <GridItem {...styles.productPartNumbersGridItem}>
                                {/* Store Custom Code - Start */}
                                <ProductLineVariantTraitValues
                                    {...styles.variantTraitValues}
                                    productId={cartLine.productId}
                                />
                                {/* Store Custom Code - End */}
                                <ProductPartNumbers
                                    productNumber={cartLine.erpNumber}
                                    customerProductNumber={cartLine.customerName}
                                    manufacturerItem={cartLine.manufacturerItem}
                                    extendedStyles={styles.productPartNumbers}
                                />
                            </GridItem>
                            {/* Starter Custom Code - End */}
                            {!cartLine.isFixedConfiguration && cartLine.sectionOptions!.length > 0 && (
                                <GridItem {...styles.configurationGridItem}>
                                    {cartLine.sectionOptions!.map(option => (
                                        <Typography {...styles.configurationOptionText} key={option.sectionOptionId}>
                                            {`${option.sectionName}:${option.optionName}`}
                                        </Typography>
                                    ))}
                                </GridItem>
                            )}
                            {/* Starter Custom Code - Start */}
                            {cart.showCostCode && cartLine.costCode && (
                                <GridItem {...styles.costCodeGridItem} data-test-selector="orderConformation_CostCode">
                                    <Typography {...styles.costCodeLabelText}>{cart.costCodeLabel}</Typography>
                                    <Typography {...styles.costCodeValueText}>{cartLine.costCode}</Typography>
                                </GridItem>
                            )}
                            {/* Starter Custom Code - End */}
                        </GridContainer>
                    </GridItem>
                    <GridItem {...styles.productPriceAndQuantityGridItem}>
                        <GridContainer {...styles.productPriceAndQuantityContainer}>
                            {(showPricing || isCheckoutReviewAndSubmitPage) /* Starter Custom Code */ && (
                                <GridItem {...styles.priceGridItem}>
                                    <ProductPrice
                                        product={cartLine}
                                        showSavings={true}
                                        showSavingsAmount={showSavingsAmount}
                                        showSavingsPercent={showSavingsPercent}
                                        showInvalidPriceMessage={showInvalidPriceMessage}
                                        extendedStyles={styles.price}
                                    />
                                    {/* Starter Custom Code - Start */}
                                    {promotions && promotions.length > 0 && (
                                        <Typography
                                            {...styles.promotionNameText}
                                            data-test-selector="orderLineCardExpandedPromotionName"
                                        >
                                            {translate("{0}:", translate("Promotions"))}{" "}
                                            {promotions.map(x => x.name).join(", ")}
                                        </Typography>
                                    )}
                                    {/* Starter Custom Code - End */}
                                </GridItem>
                            )}
                            <GridItem {...styles.quantityGridItem} data-test-selector="orderConformation_Quantity">
                                <CartLineQuantity cart={cart} editable={editable} extendedStyles={styles.quantity} />
                            </GridItem>
                            {/* Starter Custom Code - Start */}
                            {cartLine.pricing && (showPricing || isCheckoutReviewAndSubmitPage) && (
                                <GridItem {...styles.extendedUnitNetPriceGridItem}>
                                    <Typography {...styles.extendedUnitNetPriceLabel}>
                                        {translate("Subtotal")}
                                    </Typography>
                                    <Typography {...styles.extendedUnitNetPriceText}>
                                        {enableVat && vatPriceDisplay !== "DisplayWithoutVat"
                                            ? cartLine.pricing.extendedUnitRegularPriceWithVatDisplay
                                            : cartLine.pricing.extendedUnitNetPriceDisplay}
                                    </Typography>
                                    {enableVat && (
                                        <>
                                            <Typography {...styles.vatLabelText}>
                                                {vatPriceDisplay === "DisplayWithVat" ||
                                                vatPriceDisplay === "DisplayWithAndWithoutVat"
                                                    ? `${translate("Inc. VAT")} (${cartLine.pricing.vatRate}%)`
                                                    : translate("Ex. VAT")}
                                            </Typography>
                                            {vatPriceDisplay === "DisplayWithAndWithoutVat" && (
                                                <>
                                                    <Typography {...styles.subtotalWithoutVat}>
                                                        {cartLine.pricing.extendedUnitNetPriceDisplay}
                                                    </Typography>
                                                    <Typography {...styles.vatLabelText}>
                                                        {translate("Ex. VAT")}
                                                    </Typography>
                                                </>
                                            )}
                                        </>
                                    )}
                                </GridItem>
                            )}
                            {/* Starter Custom Code - End */}
                        </GridContainer>
                    </GridItem>
                </GridContainer>
                {/* Starter Custom Code - Start */}
                {cartLine.notes && (
                    <CartLineNotes
                        cart={cart}
                        editable={editable}
                        label={translate("Line Notes")}
                        extendedStyles={styles.cartLineNotes}
                    />
                )}
                {/* Starter Custom Code - End */}
            </GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps)(withCartLine(CartLineCardExpanded));
